import { IFullPlanDetail } from "../../../interfaces/api";
import SingleInfoBenefit from "./SingleInfoBenefit.component";
import {
  getDoubleDeepHMO,
  getSingleDeepHMO,
} from "../../../functions/planDetails";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const DataTableDetailExtra = ({ data }: { data: IFullPlanDetail }) => {
  const { selectedYear } = useZipRootLoaderData();
  const inpatientHospitalBenefit = getSingleDeepHMO(
    data,
    "Over-The-Counter (OTC)"
  );
  const caregiverBenefit = getSingleDeepHMO(
    data,
    "Support for Care Givers Of Enrollee"
  );
  const acupunctureBenefit = getDoubleDeepHMO(
    data,
    "Acupuncture And Reflexology",
    "Acupuncture (Medicare and Routine)"
  );
  const chiropracticBenefit = getSingleDeepHMO(data, "Chiropractic Services");
  const fitnessBenefit = getSingleDeepHMO(data, "Fitness");
  const telehealthBenefit = getDoubleDeepHMO(
    data,
    "Doctor visits",
    selectedYear === 2024
      ? "Additional Telehealth Benefits"
      : "Additional Telehealth Services"
  );
  const homeSupportBenefit = getSingleDeepHMO(data, "In-Home Support Services");
  const worldwideBenefit = getSingleDeepHMO(
    data,
    "Worldwide Emergency/ Urgent Coverage"
  );
  const durableMedicalBenefit = getDoubleDeepHMO(
    data,
    "Medical Equipment",
    "Durable Medical Equipment (DME)"
  );

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <SingleInfoBenefit
        benefit={[
          {
            pbpBenefitDesc: " $0",
            pbpBenefitName: null,
            vendorDetails: null,
          },
        ]}
        title="24/7 Concierge Service"
      />
      <SingleInfoBenefit
        benefit={inpatientHospitalBenefit}
        title="Over-the-Counter (OTC) Allowance"
      />
      <SingleInfoBenefit benefit={caregiverBenefit} title="Caregiver Support" />
      <SingleInfoBenefit benefit={acupunctureBenefit} title="Acupuncture" />
      <SingleInfoBenefit
        benefit={chiropracticBenefit}
        title="Chiropractic Services"
      />
      <SingleInfoBenefit benefit={fitnessBenefit} title="Fitness" />
      <SingleInfoBenefit benefit={telehealthBenefit} title="Telehealth" />
      <SingleInfoBenefit benefit={homeSupportBenefit} title="In-Home Support" />
      <SingleInfoBenefit
        benefit={worldwideBenefit}
        title="Worldwide Emergency / Urgent Coverage"
      />
      <SingleInfoBenefit
        benefit={durableMedicalBenefit}
        title="Durable Medical Equipment"
      />
    </div>
  );
};

export default DataTableDetailExtra;
